export const paletteCatalog = [
  {
    name: 'apricot',
    label: '杏橙',
    swatches: [
      { step: '600', cssVariable: '--palette-apricot-600', value: '#FFA54D' },
    ],
  },
  {
    name: 'blackAlpha',
    label: '黑色透明',
    swatches: [
      { step: '10', cssVariable: '--palette-black-alpha-10', value: '#0000001A' },
      { step: '100', cssVariable: '--palette-black-alpha-100', value: '#000000' },
      { step: '12', cssVariable: '--palette-black-alpha-12', value: '#0000001F' },
      { step: '16', cssVariable: '--palette-black-alpha-16', value: '#00000029' },
      { step: '2', cssVariable: '--palette-black-alpha-2', value: '#00000005' },
      { step: '20', cssVariable: '--palette-black-alpha-20', value: '#00000033' },
      { step: '25', cssVariable: '--palette-black-alpha-25', value: '#00000040' },
      { step: '30', cssVariable: '--palette-black-alpha-30', value: '#0000004D' },
      { step: '36', cssVariable: '--palette-black-alpha-36', value: '#0000005C' },
      { step: '4', cssVariable: '--palette-black-alpha-4', value: '#0000000A' },
      { step: '40', cssVariable: '--palette-black-alpha-40', value: '#00000066' },
      { step: '45', cssVariable: '--palette-black-alpha-45', value: '#00000073' },
      { step: '50', cssVariable: '--palette-black-alpha-50', value: '#00000080' },
      { step: '55', cssVariable: '--palette-black-alpha-55', value: '#0000008C' },
      { step: '6', cssVariable: '--palette-black-alpha-6', value: '#0000000F' },
      { step: '60', cssVariable: '--palette-black-alpha-60', value: '#00000099' },
      { step: '65', cssVariable: '--palette-black-alpha-65', value: '#000000A6' },
      { step: '72', cssVariable: '--palette-black-alpha-72', value: '#000000B8' },
      { step: '8', cssVariable: '--palette-black-alpha-8', value: '#00000014' },
      { step: '80', cssVariable: '--palette-black-alpha-80', value: '#000000CC' },
      { step: '90', cssVariable: '--palette-black-alpha-90', value: '#000000E5' },
    ],
  },
  {
    name: 'blossom',
    label: '花粉',
    swatches: [
      { step: '600', cssVariable: '--palette-blossom-600', value: '#FF78AA' },
    ],
  },
  {
    name: 'blue',
    label: '蓝色',
    swatches: [
      { step: '100', cssVariable: '--palette-blue-100', value: '#ECF5FF' },
      { step: '200', cssVariable: '--palette-blue-200', value: '#D9ECFF' },
      { step: '300', cssVariable: '--palette-blue-300', value: '#C6E2FF' },
      { step: '400', cssVariable: '--palette-blue-400', value: '#9FCEFF' },
      { step: '500', cssVariable: '--palette-blue-500', value: '#79BBFF' },
      { step: '600', cssVariable: '--palette-blue-600', value: '#2878E8' },
      { step: '700', cssVariable: '--palette-blue-700', value: '#337ECC' },
      { step: '800', cssVariable: '--palette-blue-800', value: '#2056A2' },
    ],
  },
  {
    name: 'cornflower',
    label: '柔和矢车菊蓝',
    swatches: [
      { step: '100', cssVariable: '--palette-cornflower-100', value: '#EDF3FB' },
      { step: '600', cssVariable: '--palette-cornflower-600', value: '#5B8FD4' },
    ],
  },
  {
    name: 'cyan',
    label: '青色',
    swatches: [
      { step: '100', cssVariable: '--palette-cyan-100', value: '#E6F8F8' },
      { step: '200', cssVariable: '--palette-cyan-200', value: '#C7F0F0' },
      { step: '300', cssVariable: '--palette-cyan-300', value: '#A7E7E7' },
      { step: '400', cssVariable: '--palette-cyan-400', value: '#72D6D6' },
      { step: '500', cssVariable: '--palette-cyan-500', value: '#46C2C2' },
      { step: '600', cssVariable: '--palette-cyan-600', value: '#1D9F9F' },
      { step: '700', cssVariable: '--palette-cyan-700', value: '#147A7A' },
      { step: '800', cssVariable: '--palette-cyan-800', value: '#0D5D5D' },
    ],
  },
  {
    name: 'darkBlue',
    label: '暗黑蓝色',
    swatches: [
      { step: '100', cssVariable: '--palette-dark-blue-100', value: '#66B1FF' },
      { step: '200', cssVariable: '--palette-dark-blue-200', value: '#409EFF' },
      { step: '300', cssVariable: '--palette-dark-blue-300', value: '#3375B9' },
      { step: '400', cssVariable: '--palette-dark-blue-400', value: '#2056A2' },
      { step: '500', cssVariable: '--palette-dark-blue-500', value: '#2A598A' },
      { step: '600', cssVariable: '--palette-dark-blue-600', value: '#213D5B' },
      { step: '700', cssVariable: '--palette-dark-blue-700', value: '#1D3043' },
      { step: '800', cssVariable: '--palette-dark-blue-800', value: '#18222C' },
    ],
  },
  {
    name: 'darkCyan',
    label: '暗黑青色',
    swatches: [
      { step: '100', cssVariable: '--palette-dark-cyan-100', value: '#A6E3E3' },
      { step: '200', cssVariable: '--palette-dark-cyan-200', value: '#79D1D1' },
      { step: '300', cssVariable: '--palette-dark-cyan-300', value: '#5AA6A6' },
      { step: '400', cssVariable: '--palette-dark-cyan-400', value: '#437D7D' },
      { step: '500', cssVariable: '--palette-dark-cyan-500', value: '#2E5656' },
      { step: '600', cssVariable: '--palette-dark-cyan-600', value: '#224040' },
      { step: '700', cssVariable: '--palette-dark-cyan-700', value: '#192F2F' },
      { step: '800', cssVariable: '--palette-dark-cyan-800', value: '#122222' },
    ],
  },
  {
    name: 'darkGreen',
    label: '暗黑绿色',
    swatches: [
      { step: '100', cssVariable: '--palette-dark-green-100', value: '#85CE61' },
      { step: '200', cssVariable: '--palette-dark-green-200', value: '#67C23A' },
      { step: '300', cssVariable: '--palette-dark-green-300', value: '#4E8E2F' },
      { step: '400', cssVariable: '--palette-dark-green-400', value: '#3E6B27' },
      { step: '500', cssVariable: '--palette-dark-green-500', value: '#2D481F' },
      { step: '600', cssVariable: '--palette-dark-green-600', value: '#25371C' },
      { step: '700', cssVariable: '--palette-dark-green-700', value: '#1C2518' },
    ],
  },
  {
    name: 'darkNeutral',
    label: '暗黑中性色',
    swatches: [
      { step: '100', cssVariable: '--palette-dark-neutral-100', value: '#FFFFFF' },
      { step: '150', cssVariable: '--palette-dark-neutral-150', value: '#E5EAF3' },
      { step: '200', cssVariable: '--palette-dark-neutral-200', value: '#CFD3DC' },
      { step: '250', cssVariable: '--palette-dark-neutral-250', value: '#A3A6AD' },
      { step: '300', cssVariable: '--palette-dark-neutral-300', value: '#909399' },
      { step: '350', cssVariable: '--palette-dark-neutral-350', value: '#8D9095' },
      { step: '400', cssVariable: '--palette-dark-neutral-400', value: '#6C6E72' },
      { step: '450', cssVariable: '--palette-dark-neutral-450', value: '#636466' },
      { step: '500', cssVariable: '--palette-dark-neutral-500', value: '#4C4D4F' },
      { step: '550', cssVariable: '--palette-dark-neutral-550', value: '#363637' },
      { step: '600', cssVariable: '--palette-dark-neutral-600', value: '#303030' },
      { step: '650', cssVariable: '--palette-dark-neutral-650', value: '#262727' },
      { step: '700', cssVariable: '--palette-dark-neutral-700', value: '#1D1E1F' },
      { step: '750', cssVariable: '--palette-dark-neutral-750', value: '#1D1D1D' },
      { step: '800', cssVariable: '--palette-dark-neutral-800', value: '#141414' },
      { step: '900', cssVariable: '--palette-dark-neutral-900', value: '#0A0A0A' },
    ],
  },
  {
    name: 'darkOrange',
    label: '暗黑橙色',
    swatches: [
      { step: '100', cssVariable: '--palette-dark-orange-100', value: '#EBB563' },
      { step: '200', cssVariable: '--palette-dark-orange-200', value: '#E6A23C' },
      { step: '300', cssVariable: '--palette-dark-orange-300', value: '#A77730' },
      { step: '400', cssVariable: '--palette-dark-orange-400', value: '#7D5B28' },
      { step: '500', cssVariable: '--palette-dark-orange-500', value: '#533F20' },
      { step: '600', cssVariable: '--palette-dark-orange-600', value: '#3E301C' },
      { step: '700', cssVariable: '--palette-dark-orange-700', value: '#292218' },
    ],
  },
  {
    name: 'darkRed',
    label: '暗黑红色',
    swatches: [
      { step: '100', cssVariable: '--palette-dark-red-100', value: '#F78989' },
      { step: '200', cssVariable: '--palette-dark-red-200', value: '#F56C6C' },
      { step: '300', cssVariable: '--palette-dark-red-300', value: '#B25252' },
      { step: '400', cssVariable: '--palette-dark-red-400', value: '#854040' },
      { step: '500', cssVariable: '--palette-dark-red-500', value: '#582E2E' },
      { step: '600', cssVariable: '--palette-dark-red-600', value: '#412626' },
      { step: '700', cssVariable: '--palette-dark-red-700', value: '#2B1D1D' },
    ],
  },
  {
    name: 'darkSlate',
    label: '暗黑石板灰',
    swatches: [
      { step: '100', cssVariable: '--palette-dark-slate-100', value: '#A6A9AD' },
      { step: '200', cssVariable: '--palette-dark-slate-200', value: '#909399' },
      { step: '300', cssVariable: '--palette-dark-slate-300', value: '#6B6D71' },
      { step: '400', cssVariable: '--palette-dark-slate-400', value: '#525457' },
      { step: '500', cssVariable: '--palette-dark-slate-500', value: '#393A3C' },
      { step: '600', cssVariable: '--palette-dark-slate-600', value: '#2D2D2F' },
      { step: '700', cssVariable: '--palette-dark-slate-700', value: '#202121' },
    ],
  },
  {
    name: 'darkViolet',
    label: '暗黑紫罗兰色',
    swatches: [
      { step: '100', cssVariable: '--palette-dark-violet-100', value: '#C8BAFF' },
      { step: '200', cssVariable: '--palette-dark-violet-200', value: '#AA96FF' },
      { step: '300', cssVariable: '--palette-dark-violet-300', value: '#8574CC' },
      { step: '400', cssVariable: '--palette-dark-violet-400', value: '#645899' },
      { step: '500', cssVariable: '--palette-dark-violet-500', value: '#443D66' },
      { step: '600', cssVariable: '--palette-dark-violet-600', value: '#332E4D' },
      { step: '700', cssVariable: '--palette-dark-violet-700', value: '#272238' },
      { step: '800', cssVariable: '--palette-dark-violet-800', value: '#1D1929' },
    ],
  },
  {
    name: 'green',
    label: '绿色',
    swatches: [
      { step: '100', cssVariable: '--palette-green-100', value: '#E5F7EA' },
      { step: '200', cssVariable: '--palette-green-200', value: '#CCF0D4' },
      { step: '300', cssVariable: '--palette-green-300', value: '#B2E8BF' },
      { step: '400', cssVariable: '--palette-green-400', value: '#80D995' },
      { step: '500', cssVariable: '--palette-green-500', value: '#4CCA6A' },
      { step: '600', cssVariable: '--palette-green-600', value: '#00B42A' },
      { step: '700', cssVariable: '--palette-green-700', value: '#427C25' },
    ],
  },
  {
    name: 'iceBlue',
    label: '冰蓝',
    swatches: [
      { step: '100', cssVariable: '--palette-ice-blue-100', value: '#76A3D1' },
    ],
  },
  {
    name: 'lavender',
    label: '薰衣草紫',
    swatches: [
      { step: '100', cssVariable: '--palette-lavender-100', value: '#8C88CE' },
    ],
  },
  {
    name: 'lime',
    label: '青柠',
    swatches: [
      { step: '600', cssVariable: '--palette-lime-600', value: '#8ED915' },
    ],
  },
  {
    name: 'mint',
    label: '薄荷绿',
    swatches: [
      { step: '100', cssVariable: '--palette-mint-100', value: '#84C6B8' },
    ],
  },
  {
    name: 'neutral',
    label: '中性色',
    swatches: [
      { step: '100', cssVariable: '--palette-neutral-100', value: '#FFFFFF' },
      { step: '150', cssVariable: '--palette-neutral-150', value: '#FAFAFA' },
      { step: '200', cssVariable: '--palette-neutral-200', value: '#F5F7FA' },
      { step: '250', cssVariable: '--palette-neutral-250', value: '#F2F3F5' },
      { step: '275', cssVariable: '--palette-neutral-275', value: '#F2F5FC' },
      { step: '300', cssVariable: '--palette-neutral-300', value: '#F0F2F5' },
      { step: '350', cssVariable: '--palette-neutral-350', value: '#E6E8EB' },
      { step: '400', cssVariable: '--palette-neutral-400', value: '#EBEEF5' },
      { step: '450', cssVariable: '--palette-neutral-450', value: '#E4E7ED' },
      { step: '500', cssVariable: '--palette-neutral-500', value: '#DCDFE6' },
      { step: '550', cssVariable: '--palette-neutral-550', value: '#CDD0D6' },
      { step: '600', cssVariable: '--palette-neutral-600', value: '#C0C4CC' },
      { step: '650', cssVariable: '--palette-neutral-650', value: '#A8ABB2' },
      { step: '700', cssVariable: '--palette-neutral-700', value: '#909399' },
      { step: '800', cssVariable: '--palette-neutral-800', value: '#606266' },
      { step: '900', cssVariable: '--palette-neutral-900', value: '#303133' },
    ],
  },
  {
    name: 'orange',
    label: '橙色',
    swatches: [
      { step: '100', cssVariable: '--palette-orange-100', value: '#FFF2E5' },
      { step: '200', cssVariable: '--palette-orange-200', value: '#FFE5CC' },
      { step: '300', cssVariable: '--palette-orange-300', value: '#FFD8B2' },
      { step: '400', cssVariable: '--palette-orange-400', value: '#FFBE80' },
      { step: '500', cssVariable: '--palette-orange-500', value: '#FFA44C' },
      { step: '600', cssVariable: '--palette-orange-600', value: '#FF7D00' },
      { step: '700', cssVariable: '--palette-orange-700', value: '#CC6400' },
    ],
  },
  {
    name: 'orchid',
    label: '兰紫色',
    swatches: [
      { step: '100', cssVariable: '--palette-orchid-100', value: '#E78FFF' },
      { step: '600', cssVariable: '--palette-orchid-600', value: '#8F48FA' },
    ],
  },
  {
    name: 'periwinkle',
    label: '长春花蓝',
    swatches: [
      { step: '100', cssVariable: '--palette-periwinkle-100', value: '#9099BD' },
    ],
  },
  {
    name: 'red',
    label: '红色',
    swatches: [
      { step: '100', cssVariable: '--palette-red-100', value: '#FEECEC' },
      { step: '200', cssVariable: '--palette-red-200', value: '#FDD9D9' },
      { step: '300', cssVariable: '--palette-red-300', value: '#FCC5C5' },
      { step: '400', cssVariable: '--palette-red-400', value: '#FA9F9F' },
      { step: '500', cssVariable: '--palette-red-500', value: '#F87979' },
      { step: '600', cssVariable: '--palette-red-600', value: '#F53F3F' },
      { step: '700', cssVariable: '--palette-red-700', value: '#C43232' },
    ],
  },
  {
    name: 'rose',
    label: '柔和玫粉色',
    swatches: [
      { step: '100', cssVariable: '--palette-rose-100', value: '#FBEEF2' },
      { step: '600', cssVariable: '--palette-rose-600', value: '#D87897' },
    ],
  },
  {
    name: 'slate',
    label: '石板灰',
    swatches: [
      { step: '100', cssVariable: '--palette-slate-100', value: '#F4F4F5' },
      { step: '200', cssVariable: '--palette-slate-200', value: '#E9E9EB' },
      { step: '300', cssVariable: '--palette-slate-300', value: '#DEDFE0' },
      { step: '400', cssVariable: '--palette-slate-400', value: '#C7C9CC' },
      { step: '500', cssVariable: '--palette-slate-500', value: '#B1B3B8' },
      { step: '600', cssVariable: '--palette-slate-600', value: '#909399' },
      { step: '700', cssVariable: '--palette-slate-700', value: '#73767A' },
    ],
  },
  {
    name: 'sunflower',
    label: '向日葵黄',
    swatches: [
      { step: '600', cssVariable: '--palette-sunflower-600', value: '#F3C11B' },
    ],
  },
  {
    name: 'violet',
    label: '紫罗兰色',
    swatches: [
      { step: '100', cssVariable: '--palette-violet-100', value: '#F3EFFF' },
      { step: '200', cssVariable: '--palette-violet-200', value: '#E7DDFF' },
      { step: '300', cssVariable: '--palette-violet-300', value: '#D7C7FF' },
      { step: '400', cssVariable: '--palette-violet-400', value: '#B99BFF' },
      { step: '500', cssVariable: '--palette-violet-500', value: '#9B7BFF' },
      { step: '600', cssVariable: '--palette-violet-600', value: '#7A5AF8' },
      { step: '700', cssVariable: '--palette-violet-700', value: '#5B42CC' },
      { step: '800', cssVariable: '--palette-violet-800', value: '#44329A' },
    ],
  },
  {
    name: 'whiteAlpha',
    label: '白色透明',
    swatches: [
      { step: '10', cssVariable: '--palette-white-alpha-10', value: '#FFFFFF1A' },
      { step: '100', cssVariable: '--palette-white-alpha-100', value: '#FFFFFF' },
      { step: '12', cssVariable: '--palette-white-alpha-12', value: '#FFFFFF1F' },
      { step: '16', cssVariable: '--palette-white-alpha-16', value: '#FFFFFF29' },
      { step: '2', cssVariable: '--palette-white-alpha-2', value: '#FFFFFF05' },
      { step: '20', cssVariable: '--palette-white-alpha-20', value: '#FFFFFF33' },
      { step: '25', cssVariable: '--palette-white-alpha-25', value: '#FFFFFF40' },
      { step: '30', cssVariable: '--palette-white-alpha-30', value: '#FFFFFF4D' },
      { step: '36', cssVariable: '--palette-white-alpha-36', value: '#FFFFFF5C' },
      { step: '4', cssVariable: '--palette-white-alpha-4', value: '#FFFFFF0A' },
      { step: '40', cssVariable: '--palette-white-alpha-40', value: '#FFFFFF66' },
      { step: '45', cssVariable: '--palette-white-alpha-45', value: '#FFFFFF73' },
      { step: '50', cssVariable: '--palette-white-alpha-50', value: '#FFFFFF80' },
      { step: '55', cssVariable: '--palette-white-alpha-55', value: '#FFFFFF8C' },
      { step: '6', cssVariable: '--palette-white-alpha-6', value: '#FFFFFF0F' },
      { step: '60', cssVariable: '--palette-white-alpha-60', value: '#FFFFFF99' },
      { step: '65', cssVariable: '--palette-white-alpha-65', value: '#FFFFFFA6' },
      { step: '72', cssVariable: '--palette-white-alpha-72', value: '#FFFFFFB8' },
      { step: '8', cssVariable: '--palette-white-alpha-8', value: '#FFFFFF14' },
      { step: '80', cssVariable: '--palette-white-alpha-80', value: '#FFFFFFCC' },
      { step: '90', cssVariable: '--palette-white-alpha-90', value: '#FFFFFFE5' },
    ],
  },
] as const;

export const roleCatalog = [
  {
    name: 'aira',
    label: 'AIRA 品牌渐变',
    lightFamily: 'orchid',
    darkFamily: 'orchid',
  },
  {
    name: 'brand',
    label: '主题色',
    lightFamily: 'blue',
    darkFamily: 'darkBlue',
  },
  {
    name: 'categoryBlue',
    label: '分类蓝色',
    lightFamily: 'blue',
    darkFamily: 'darkBlue',
  },
  {
    name: 'categoryCyan',
    label: '分类青色',
    lightFamily: 'cyan',
    darkFamily: 'darkCyan',
  },
  {
    name: 'categoryViolet',
    label: '分类紫罗兰色',
    lightFamily: 'violet',
    darkFamily: 'darkViolet',
  },
  {
    name: 'danger',
    label: '危险色',
    lightFamily: 'red',
    darkFamily: 'darkRed',
  },
  {
    name: 'genderFemale',
    label: '女性别标识',
    lightFamily: 'rose',
    darkFamily: 'rose',
  },
  {
    name: 'genderMale',
    label: '男性别标识',
    lightFamily: 'cornflower',
    darkFamily: 'cornflower',
  },
  {
    name: 'information',
    label: '信息色',
    lightFamily: 'slate',
    darkFamily: 'darkSlate',
  },
  {
    name: 'neutral',
    label: '中性色',
    lightFamily: 'neutral',
    darkFamily: 'darkNeutral',
  },
  {
    name: 'neutralAlpha',
    label: '透明中性色',
    lightFamily: 'blackAlpha',
    darkFamily: 'whiteAlpha',
  },
  {
    name: 'overlayAlpha',
    label: '覆盖层透明色',
    lightFamily: 'blackAlpha',
    darkFamily: 'blackAlpha',
  },
  {
    name: 'shadowAlpha',
    label: '阴影透明色',
    lightFamily: 'blackAlpha',
    darkFamily: 'blackAlpha',
  },
  {
    name: 'studentAvatarGreen',
    label: '学员无照片头像Green',
    lightFamily: 'lime',
    darkFamily: 'lime',
  },
  {
    name: 'studentAvatarOrange',
    label: '学员无照片头像Orange',
    lightFamily: 'apricot',
    darkFamily: 'apricot',
  },
  {
    name: 'studentAvatarPink',
    label: '学员无照片头像Pink',
    lightFamily: 'blossom',
    darkFamily: 'blossom',
  },
  {
    name: 'studentAvatarYellow',
    label: '学员无照片头像Yellow',
    lightFamily: 'sunflower',
    darkFamily: 'sunflower',
  },
  {
    name: 'success',
    label: '安全／成功色',
    lightFamily: 'green',
    darkFamily: 'darkGreen',
  },
  {
    name: 'teacherAvatarBlue',
    label: '老师无照片头像Blue',
    lightFamily: 'iceBlue',
    darkFamily: 'iceBlue',
  },
  {
    name: 'teacherAvatarGreen',
    label: '老师无照片头像Green',
    lightFamily: 'mint',
    darkFamily: 'mint',
  },
  {
    name: 'teacherAvatarIndigo',
    label: '老师无照片头像Indigo',
    lightFamily: 'periwinkle',
    darkFamily: 'periwinkle',
  },
  {
    name: 'teacherAvatarPurple',
    label: '老师无照片头像Purple',
    lightFamily: 'lavender',
    darkFamily: 'lavender',
  },
  {
    name: 'warning',
    label: '警告色',
    lightFamily: 'orange',
    darkFamily: 'darkOrange',
  },
] as const;

export const semanticColorCatalog = [
  {
    name: 'color.avatar.foreground',
    cssVariable: '--color-avatar-foreground',
    description: '固定浅亮头像底色上的深色首字母',
    lightReference: '{role.neutral.900}',
    darkReference: '{role.neutral.900}',
    lightResolved: '#303133',
    darkResolved: '#0A0A0A',
  },
  {
    name: 'color.avatar.student.green',
    cssVariable: '--color-avatar-student-green',
    description: '学员无照片头像固定色组 Green',
    lightReference: '{role.studentAvatarGreen.600}',
    darkReference: '{role.studentAvatarGreen.600}',
    lightResolved: '#8ED915',
    darkResolved: '#8ED915',
  },
  {
    name: 'color.avatar.student.orange',
    cssVariable: '--color-avatar-student-orange',
    description: '学员无照片头像固定色组 Orange',
    lightReference: '{role.studentAvatarOrange.600}',
    darkReference: '{role.studentAvatarOrange.600}',
    lightResolved: '#FFA54D',
    darkResolved: '#FFA54D',
  },
  {
    name: 'color.avatar.student.pink',
    cssVariable: '--color-avatar-student-pink',
    description: '学员无照片头像固定色组 Pink',
    lightReference: '{role.studentAvatarPink.600}',
    darkReference: '{role.studentAvatarPink.600}',
    lightResolved: '#FF78AA',
    darkResolved: '#FF78AA',
  },
  {
    name: 'color.avatar.student.yellow',
    cssVariable: '--color-avatar-student-yellow',
    description: '学员无照片头像固定色组 Yellow',
    lightReference: '{role.studentAvatarYellow.600}',
    darkReference: '{role.studentAvatarYellow.600}',
    lightResolved: '#F3C11B',
    darkResolved: '#F3C11B',
  },
  {
    name: 'color.avatar.teacher.blue',
    cssVariable: '--color-avatar-teacher-blue',
    description: '老师无照片头像固定色组 Blue',
    lightReference: '{role.teacherAvatarBlue.100}',
    darkReference: '{role.teacherAvatarBlue.100}',
    lightResolved: '#76A3D1',
    darkResolved: '#76A3D1',
  },
  {
    name: 'color.avatar.teacher.foreground',
    cssVariable: '--color-avatar-teacher-foreground',
    description: '老师无照片头像彩色底色上的反白文字',
    lightReference: '{role.neutral.100}',
    darkReference: '{role.neutral.100}',
    lightResolved: '#FFFFFF',
    darkResolved: '#FFFFFF',
  },
  {
    name: 'color.avatar.teacher.green',
    cssVariable: '--color-avatar-teacher-green',
    description: '老师无照片头像固定色组 Green',
    lightReference: '{role.teacherAvatarGreen.100}',
    darkReference: '{role.teacherAvatarGreen.100}',
    lightResolved: '#84C6B8',
    darkResolved: '#84C6B8',
  },
  {
    name: 'color.avatar.teacher.indigo',
    cssVariable: '--color-avatar-teacher-indigo',
    description: '老师无照片头像固定色组 Indigo',
    lightReference: '{role.teacherAvatarIndigo.100}',
    darkReference: '{role.teacherAvatarIndigo.100}',
    lightResolved: '#9099BD',
    darkResolved: '#9099BD',
  },
  {
    name: 'color.avatar.teacher.purple',
    cssVariable: '--color-avatar-teacher-purple',
    description: '老师无照片头像固定色组 Purple',
    lightReference: '{role.teacherAvatarPurple.100}',
    darkReference: '{role.teacherAvatarPurple.100}',
    lightResolved: '#8C88CE',
    darkResolved: '#8C88CE',
  },
  {
    name: 'color.background.ai',
    cssVariable: '--color-background-ai',
    description: 'AI 记录详情视觉强调，参考移动端 AI 模块',
    lightReference: '{role.aira.600}',
    darkReference: '{role.aira.600}',
    lightResolved: '#8F48FA',
    darkResolved: '#8F48FA',
  },
  {
    name: 'color.background.ai-soft',
    cssVariable: '--color-background-ai-soft',
    description: 'AI 记录详情视觉强调，参考移动端 AI 模块',
    lightReference: '{role.aira.100}',
    darkReference: '{role.aira.100}',
    lightResolved: '#E78FFF',
    darkResolved: '#E78FFF',
  },
  {
    name: 'color.background.brand.bold',
    cssVariable: '--color-background-brand-bold',
    description: '高强调主题色背景',
    lightReference: '{role.brand.600}',
    darkReference: '{role.brand.200}',
    lightResolved: '#2878E8',
    darkResolved: '#409EFF',
  },
  {
    name: 'color.background.brand.bold.hovered',
    cssVariable: '--color-background-brand-bold-hovered',
    description: '悬停状态高强调主题色背景',
    lightReference: '{role.brand.400}',
    darkReference: '{role.brand.100}',
    lightResolved: '#9FCEFF',
    darkResolved: '#66B1FF',
  },
  {
    name: 'color.background.brand.bold.pressed',
    cssVariable: '--color-background-brand-bold-pressed',
    description: '按下状态高强调主题色背景',
    lightReference: '{role.brand.700}',
    darkReference: '{role.brand.300}',
    lightResolved: '#337ECC',
    darkResolved: '#3375B9',
  },
  {
    name: 'color.background.brand.bolder',
    cssVariable: '--color-background-brand-bolder',
    description: '产品导航等最高强调主题色背景',
    lightReference: '{role.brand.800}',
    darkReference: '{role.brand.400}',
    lightResolved: '#2056A2',
    darkResolved: '#2056A2',
  },
  {
    name: 'color.background.brand.subtle',
    cssVariable: '--color-background-brand-subtle',
    description: '低强调主题色背景',
    lightReference: '{role.brand.100}',
    darkReference: '{role.brand.800}',
    lightResolved: '#ECF5FF',
    darkResolved: '#18222C',
  },
  {
    name: 'color.background.danger.bold',
    cssVariable: '--color-background-danger-bold',
    description: '高强调危险状态背景',
    lightReference: '{role.danger.600}',
    darkReference: '{role.danger.200}',
    lightResolved: '#F53F3F',
    darkResolved: '#F56C6C',
  },
  {
    name: 'color.background.danger.bold.hovered',
    cssVariable: '--color-background-danger-bold-hovered',
    description: '悬停状态高强调危险状态背景',
    lightReference: '{role.danger.400}',
    darkReference: '{role.danger.100}',
    lightResolved: '#FA9F9F',
    darkResolved: '#F78989',
  },
  {
    name: 'color.background.danger.bold.pressed',
    cssVariable: '--color-background-danger-bold-pressed',
    description: '按下状态高强调危险状态背景',
    lightReference: '{role.danger.700}',
    darkReference: '{role.danger.300}',
    lightResolved: '#C43232',
    darkResolved: '#B25252',
  },
  {
    name: 'color.background.danger.subtle',
    cssVariable: '--color-background-danger-subtle',
    description: '低强调危险状态背景',
    lightReference: '{role.danger.100}',
    darkReference: '{role.danger.700}',
    lightResolved: '#FEECEC',
    darkResolved: '#2B1D1D',
  },
  {
    name: 'color.background.genderFemale',
    cssVariable: '--color-background-gender-female',
    description: '女性别角标浅粉背景，用户授权的独立性别色',
    lightReference: '{role.genderFemale.100}',
    darkReference: '{role.genderFemale.100}',
    lightResolved: '#FBEEF2',
    darkResolved: '#FBEEF2',
  },
  {
    name: 'color.background.genderMale',
    cssVariable: '--color-background-gender-male',
    description: '男性别角标浅蓝背景，用户授权的独立性别色',
    lightReference: '{role.genderMale.100}',
    darkReference: '{role.genderMale.100}',
    lightResolved: '#EDF3FB',
    darkResolved: '#EDF3FB',
  },
  {
    name: 'color.background.information.bold',
    cssVariable: '--color-background-information-bold',
    description: '高强调信息状态背景',
    lightReference: '{role.information.600}',
    darkReference: '{role.information.200}',
    lightResolved: '#909399',
    darkResolved: '#909399',
  },
  {
    name: 'color.background.information.bold.hovered',
    cssVariable: '--color-background-information-bold-hovered',
    description: '悬停状态高强调信息状态背景',
    lightReference: '{role.information.400}',
    darkReference: '{role.information.100}',
    lightResolved: '#C7C9CC',
    darkResolved: '#A6A9AD',
  },
  {
    name: 'color.background.information.bold.pressed',
    cssVariable: '--color-background-information-bold-pressed',
    description: '按下状态高强调信息状态背景',
    lightReference: '{role.information.700}',
    darkReference: '{role.information.300}',
    lightResolved: '#73767A',
    darkResolved: '#6B6D71',
  },
  {
    name: 'color.background.information.subtle',
    cssVariable: '--color-background-information-subtle',
    description: '低强调信息状态背景',
    lightReference: '{role.information.100}',
    darkReference: '{role.information.700}',
    lightResolved: '#F4F4F5',
    darkResolved: '#202121',
  },
  {
    name: 'color.background.inverse',
    cssVariable: '--color-background-inverse',
    description: '深色表面上的反色背景',
    lightReference: '{role.neutral.100}',
    darkReference: '{role.neutral.100}',
    lightResolved: '#FFFFFF',
    darkResolved: '#FFFFFF',
  },
  {
    name: 'color.background.neutral.bold',
    cssVariable: '--color-background-neutral-bold',
    description: '高强调中性背景',
    lightReference: '{role.neutral.550}',
    darkReference: '{role.neutral.500}',
    lightResolved: '#CDD0D6',
    darkResolved: '#4C4D4F',
  },
  {
    name: 'color.background.neutral.bold.disabled',
    cssVariable: '--color-background-neutral-bold-disabled',
    description: '禁用状态高强调中性背景',
    lightReference: '{role.neutral.450}',
    darkReference: '{role.neutral.600}',
    lightResolved: '#E4E7ED',
    darkResolved: '#303030',
  },
  {
    name: 'color.background.neutral.bolder',
    cssVariable: '--color-background-neutral-bolder',
    description: '最高强调中性背景',
    lightReference: '{role.neutral.800}',
    darkReference: '{role.neutral.150}',
    lightResolved: '#606266',
    darkResolved: '#E5EAF3',
  },
  {
    name: 'color.background.neutral',
    cssVariable: '--color-background-neutral',
    description: '中性填充背景',
    lightReference: '{role.neutral.300}',
    darkReference: '{role.neutral.600}',
    lightResolved: '#F0F2F5',
    darkResolved: '#303030',
  },
  {
    name: 'color.background.neutral.disabled',
    cssVariable: '--color-background-neutral-disabled',
    description: '禁用状态中性填充',
    lightReference: '{role.neutral.600}',
    darkReference: '{role.neutral.400}',
    lightResolved: '#C0C4CC',
    darkResolved: '#6C6E72',
  },
  {
    name: 'color.background.neutral.selected',
    cssVariable: '--color-background-neutral-selected',
    description: '中性列表或导航的 Hover 与当前项背景',
    lightReference: '{role.neutral.350}',
    darkReference: '{role.neutral.650}',
    lightResolved: '#E6E8EB',
    darkResolved: '#262727',
  },
  {
    name: 'color.background.neutral.subtle',
    cssVariable: '--color-background-neutral-subtle',
    description: '低强调中性填充背景',
    lightReference: '{role.neutral.200}',
    darkReference: '{role.neutral.650}',
    lightResolved: '#F5F7FA',
    darkResolved: '#262727',
  },
  {
    name: 'color.background.neutral.subtlest',
    cssVariable: '--color-background-neutral-subtlest',
    description: '最低强调中性填充背景',
    lightReference: '{role.neutral.150}',
    darkReference: '{role.neutral.750}',
    lightResolved: '#FAFAFA',
    darkResolved: '#1D1D1D',
  },
  {
    name: 'color.background.page',
    cssVariable: '--color-background-page',
    description: '页面画布背景',
    lightReference: '{role.neutral.250}',
    darkReference: '{role.neutral.900}',
    lightResolved: '#F2F3F5',
    darkResolved: '#0A0A0A',
  },
  {
    name: 'color.background.scrollbar',
    cssVariable: '--color-background-scrollbar',
    description: '滚动条滑块背景',
    lightReference: '{role.neutral.350}',
    darkReference: '{role.neutral.600}',
    lightResolved: '#E6E8EB',
    darkResolved: '#303030',
  },
  {
    name: 'color.background.success.bold',
    cssVariable: '--color-background-success-bold',
    description: '高强调成功状态背景',
    lightReference: '{role.success.600}',
    darkReference: '{role.success.200}',
    lightResolved: '#00B42A',
    darkResolved: '#67C23A',
  },
  {
    name: 'color.background.success.bold.hovered',
    cssVariable: '--color-background-success-bold-hovered',
    description: '悬停状态高强调成功状态背景',
    lightReference: '{role.success.400}',
    darkReference: '{role.success.100}',
    lightResolved: '#80D995',
    darkResolved: '#85CE61',
  },
  {
    name: 'color.background.success.bold.pressed',
    cssVariable: '--color-background-success-bold-pressed',
    description: '按下状态高强调成功状态背景',
    lightReference: '{role.success.700}',
    darkReference: '{role.success.300}',
    lightResolved: '#427C25',
    darkResolved: '#4E8E2F',
  },
  {
    name: 'color.background.success.subtle',
    cssVariable: '--color-background-success-subtle',
    description: '低强调成功状态背景',
    lightReference: '{role.success.100}',
    darkReference: '{role.success.700}',
    lightResolved: '#E5F7EA',
    darkResolved: '#1C2518',
  },
  {
    name: 'color.background.surface',
    cssVariable: '--color-background-surface',
    description: '默认内容表面',
    lightReference: '{role.neutral.100}',
    darkReference: '{role.neutral.800}',
    lightResolved: '#FFFFFF',
    darkResolved: '#141414',
  },
  {
    name: 'color.background.surface.overlay',
    cssVariable: '--color-background-surface-overlay',
    description: '浮层内容表面',
    lightReference: '{role.neutral.100}',
    darkReference: '{role.neutral.700}',
    lightResolved: '#FFFFFF',
    darkResolved: '#1D1E1F',
  },
  {
    name: 'color.background.warning.bold',
    cssVariable: '--color-background-warning-bold',
    description: '高强调警告状态背景',
    lightReference: '{role.warning.600}',
    darkReference: '{role.warning.200}',
    lightResolved: '#FF7D00',
    darkResolved: '#E6A23C',
  },
  {
    name: 'color.background.warning.bold.hovered',
    cssVariable: '--color-background-warning-bold-hovered',
    description: '悬停状态高强调警告状态背景',
    lightReference: '{role.warning.400}',
    darkReference: '{role.warning.100}',
    lightResolved: '#FFBE80',
    darkResolved: '#EBB563',
  },
  {
    name: 'color.background.warning.bold.pressed',
    cssVariable: '--color-background-warning-bold-pressed',
    description: '按下状态高强调警告状态背景',
    lightReference: '{role.warning.700}',
    darkReference: '{role.warning.300}',
    lightResolved: '#CC6400',
    darkResolved: '#A77730',
  },
  {
    name: 'color.background.warning.subtle',
    cssVariable: '--color-background-warning-subtle',
    description: '低强调警告状态背景',
    lightReference: '{role.warning.100}',
    darkReference: '{role.warning.700}',
    lightResolved: '#FFF2E5',
    darkResolved: '#292218',
  },
  {
    name: 'color.border.ai',
    cssVariable: '--color-border-ai',
    description: 'AI 记录详情视觉强调，参考移动端 AI 模块',
    lightReference: '{role.aira.600}',
    darkReference: '{role.aira.600}',
    lightResolved: '#8F48FA',
    darkResolved: '#8F48FA',
  },
  {
    name: 'color.border.bolder',
    cssVariable: '--color-border-bolder',
    description: '最高强调中性边框，用于手机预览外壳等需要最深描边的装饰面',
    lightReference: '{role.neutral.900}',
    darkReference: '{role.neutral.150}',
    lightResolved: '#303133',
    darkResolved: '#E5EAF3',
  },
  {
    name: 'color.border.brand',
    cssVariable: '--color-border-brand',
    description: '主题色边框',
    lightReference: '{role.brand.600}',
    darkReference: '{role.brand.200}',
    lightResolved: '#2878E8',
    darkResolved: '#409EFF',
  },
  {
    name: 'color.border.brandLight',
    cssVariable: '--color-border-brand-light',
    description: '浅色主题色边框',
    lightReference: '{role.brand.400}',
    darkReference: '{role.brand.100}',
    lightResolved: '#9FCEFF',
    darkResolved: '#66B1FF',
  },
  {
    name: 'color.border.brandPressed',
    cssVariable: '--color-border-brand-pressed',
    description: '主题色按下边框',
    lightReference: '{role.brand.700}',
    darkReference: '{role.brand.300}',
    lightResolved: '#337ECC',
    darkResolved: '#3375B9',
  },
  {
    name: 'color.border.brandSubtle',
    cssVariable: '--color-border-brand-subtle',
    description: '低强调主题色状态边框',
    lightReference: '{role.brand.300}',
    darkReference: '{role.brand.500}',
    lightResolved: '#C6E2FF',
    darkResolved: '#2A598A',
  },
  {
    name: 'color.border.danger',
    cssVariable: '--color-border-danger',
    description: '危险状态边框',
    lightReference: '{role.danger.600}',
    darkReference: '{role.danger.200}',
    lightResolved: '#F53F3F',
    darkResolved: '#F56C6C',
  },
  {
    name: 'color.border.dangerLight',
    cssVariable: '--color-border-danger-light',
    description: '浅色危险边框',
    lightReference: '{role.danger.400}',
    darkReference: '{role.danger.100}',
    lightResolved: '#FA9F9F',
    darkResolved: '#F78989',
  },
  {
    name: 'color.border.dangerSubtle',
    cssVariable: '--color-border-danger-subtle',
    description: '危险状态边框',
    lightReference: '{role.danger.300}',
    darkReference: '{role.danger.500}',
    lightResolved: '#FCC5C5',
    darkResolved: '#582E2E',
  },
  {
    name: 'color.border',
    cssVariable: '--color-border',
    description: '默认边框',
    lightReference: '{role.neutral.500}',
    darkReference: '{role.neutral.500}',
    lightResolved: '#DCDFE6',
    darkResolved: '#4C4D4F',
  },
  {
    name: 'color.border.focused',
    cssVariable: '--color-border-focused',
    description: '焦点边框',
    lightReference: '{role.brand.600}',
    darkReference: '{role.brand.200}',
    lightResolved: '#2878E8',
    darkResolved: '#409EFF',
  },
  {
    name: 'color.border.information',
    cssVariable: '--color-border-information',
    description: '信息状态边框',
    lightReference: '{role.information.600}',
    darkReference: '{role.information.200}',
    lightResolved: '#909399',
    darkResolved: '#909399',
  },
  {
    name: 'color.border.informationLight',
    cssVariable: '--color-border-information-light',
    description: '浅色信息边框',
    lightReference: '{role.information.400}',
    darkReference: '{role.information.100}',
    lightResolved: '#C7C9CC',
    darkResolved: '#A6A9AD',
  },
  {
    name: 'color.border.informationSubtle',
    cssVariable: '--color-border-information-subtle',
    description: '低强调信息状态边框',
    lightReference: '{role.information.300}',
    darkReference: '{role.information.500}',
    lightResolved: '#DEDFE0',
    darkResolved: '#393A3C',
  },
  {
    name: 'color.border.inverse',
    cssVariable: '--color-border-inverse',
    description: '深色表面上的反色边框',
    lightReference: '{role.neutral.100}',
    darkReference: '{role.neutral.100}',
    lightResolved: '#FFFFFF',
    darkResolved: '#FFFFFF',
  },
  {
    name: 'color.border.light',
    cssVariable: '--color-border-light',
    description: '浅色中性边框',
    lightReference: '{role.neutral.450}',
    darkReference: '{role.neutral.500}',
    lightResolved: '#E4E7ED',
    darkResolved: '#4C4D4F',
  },
  {
    name: 'color.border.lighter',
    cssVariable: '--color-border-lighter',
    description: '最浅中性边框',
    lightReference: '{role.neutral.275}',
    darkReference: '{role.neutral.550}',
    lightResolved: '#F2F5FC',
    darkResolved: '#363637',
  },
  {
    name: 'color.border.strong',
    cssVariable: '--color-border-strong',
    description: '高强调边框',
    lightReference: '{role.neutral.550}',
    darkReference: '{role.neutral.450}',
    lightResolved: '#CDD0D6',
    darkResolved: '#636466',
  },
  {
    name: 'color.border.subtle',
    cssVariable: '--color-border-subtle',
    description: '低强调边框',
    lightReference: '{role.neutral.400}',
    darkReference: '{role.neutral.550}',
    lightResolved: '#EBEEF5',
    darkResolved: '#363637',
  },
  {
    name: 'color.border.success',
    cssVariable: '--color-border-success',
    description: '成功状态边框',
    lightReference: '{role.success.600}',
    darkReference: '{role.success.200}',
    lightResolved: '#00B42A',
    darkResolved: '#67C23A',
  },
  {
    name: 'color.border.successLight',
    cssVariable: '--color-border-success-light',
    description: '浅色成功边框',
    lightReference: '{role.success.400}',
    darkReference: '{role.success.100}',
    lightResolved: '#80D995',
    darkResolved: '#85CE61',
  },
  {
    name: 'color.border.successSubtle',
    cssVariable: '--color-border-success-subtle',
    description: '成功状态边框',
    lightReference: '{role.success.300}',
    darkReference: '{role.success.500}',
    lightResolved: '#B2E8BF',
    darkResolved: '#2D481F',
  },
  {
    name: 'color.border.warning',
    cssVariable: '--color-border-warning',
    description: '警告状态边框',
    lightReference: '{role.warning.600}',
    darkReference: '{role.warning.200}',
    lightResolved: '#FF7D00',
    darkResolved: '#E6A23C',
  },
  {
    name: 'color.border.warningLight',
    cssVariable: '--color-border-warning-light',
    description: '浅色警告边框',
    lightReference: '{role.warning.400}',
    darkReference: '{role.warning.100}',
    lightResolved: '#FFBE80',
    darkResolved: '#EBB563',
  },
  {
    name: 'color.border.warningSubtle',
    cssVariable: '--color-border-warning-subtle',
    description: '警告状态边框',
    lightReference: '{role.warning.300}',
    darkReference: '{role.warning.500}',
    lightResolved: '#FFD8B2',
    darkResolved: '#533F20',
  },
  {
    name: 'color.icon.airaEnd',
    cssVariable: '--color-icon-aira-end',
    description: 'AIRA 图标底部渐变色，用户指定',
    lightReference: '{role.aira.600}',
    darkReference: '{role.aira.600}',
    lightResolved: '#8F48FA',
    darkResolved: '#8F48FA',
  },
  {
    name: 'color.icon.airaStart',
    cssVariable: '--color-icon-aira-start',
    description: 'AIRA 图标顶部渐变色，用户指定',
    lightReference: '{role.aira.100}',
    darkReference: '{role.aira.100}',
    lightResolved: '#E78FFF',
    darkResolved: '#E78FFF',
  },
  {
    name: 'color.icon.brand',
    cssVariable: '--color-icon-brand',
    description: '主题色图标',
    lightReference: '{role.brand.600}',
    darkReference: '{role.brand.200}',
    lightResolved: '#2878E8',
    darkResolved: '#409EFF',
  },
  {
    name: 'color.icon.danger',
    cssVariable: '--color-icon-danger',
    description: '危险状态图标',
    lightReference: '{role.danger.600}',
    darkReference: '{role.danger.200}',
    lightResolved: '#F53F3F',
    darkResolved: '#F56C6C',
  },
  {
    name: 'color.icon',
    cssVariable: '--color-icon',
    description: '默认图标',
    lightReference: '{role.neutral.900}',
    darkReference: '{role.neutral.150}',
    lightResolved: '#303133',
    darkResolved: '#E5EAF3',
  },
  {
    name: 'color.icon.disabled',
    cssVariable: '--color-icon-disabled',
    description: '禁用状态图标',
    lightReference: '{role.neutral.600}',
    darkReference: '{role.neutral.400}',
    lightResolved: '#C0C4CC',
    darkResolved: '#6C6E72',
  },
  {
    name: 'color.icon.genderFemale',
    cssVariable: '--color-icon-gender-female',
    description: '女性别符号正色，与浅粉角标背景成对使用',
    lightReference: '{role.genderFemale.600}',
    darkReference: '{role.genderFemale.600}',
    lightResolved: '#D87897',
    darkResolved: '#D87897',
  },
  {
    name: 'color.icon.genderMale',
    cssVariable: '--color-icon-gender-male',
    description: '男性别符号正色，与浅蓝角标背景成对使用',
    lightReference: '{role.genderMale.600}',
    darkReference: '{role.genderMale.600}',
    lightResolved: '#5B8FD4',
    darkResolved: '#5B8FD4',
  },
  {
    name: 'color.icon.information',
    cssVariable: '--color-icon-information',
    description: '信息状态图标',
    lightReference: '{role.information.700}',
    darkReference: '{role.information.300}',
    lightResolved: '#73767A',
    darkResolved: '#6B6D71',
  },
  {
    name: 'color.icon.inverse',
    cssVariable: '--color-icon-inverse',
    description: '深色背景上的反色图标',
    lightReference: '{role.neutral.100}',
    darkReference: '{role.neutral.100}',
    lightResolved: '#FFFFFF',
    darkResolved: '#FFFFFF',
  },
  {
    name: 'color.icon.placeholder',
    cssVariable: '--color-icon-placeholder',
    description: '占位提示图标',
    lightReference: '{role.neutral.650}',
    darkReference: '{role.neutral.350}',
    lightResolved: '#A8ABB2',
    darkResolved: '#8D9095',
  },
  {
    name: 'color.icon.subtle',
    cssVariable: '--color-icon-subtle',
    description: '次要图标',
    lightReference: '{role.neutral.800}',
    darkReference: '{role.neutral.200}',
    lightResolved: '#606266',
    darkResolved: '#CFD3DC',
  },
  {
    name: 'color.icon.success',
    cssVariable: '--color-icon-success',
    description: '成功状态图标',
    lightReference: '{role.success.600}',
    darkReference: '{role.success.200}',
    lightResolved: '#00B42A',
    darkResolved: '#67C23A',
  },
  {
    name: 'color.icon.warning',
    cssVariable: '--color-icon-warning',
    description: '警告状态图标',
    lightReference: '{role.warning.600}',
    darkReference: '{role.warning.200}',
    lightResolved: '#FF7D00',
    darkResolved: '#E6A23C',
  },
  {
    name: 'color.overlay.emphasis',
    cssVariable: '--color-overlay-emphasis',
    description: '新手引导遮罩等强强调覆盖层',
    lightReference: '{role.overlayAlpha.45}',
    darkReference: '{role.overlayAlpha.45}',
    lightResolved: '#00000073',
    darkResolved: '#00000073',
  },
  {
    name: 'color.overlay.neutral',
    cssVariable: '--color-overlay-neutral',
    description: '中性半透明覆盖层',
    lightReference: '{role.overlayAlpha.16}',
    darkReference: '{role.overlayAlpha.16}',
    lightResolved: '#00000029',
    darkResolved: '#00000029',
  },
  {
    name: 'color.shadow',
    cssVariable: '--color-shadow',
    description: '默认组合阴影颜色',
    lightReference: '{role.shadowAlpha.8}',
    darkReference: '{role.shadowAlpha.8}',
    lightResolved: '#00000014',
    darkResolved: '#00000014',
  },
  {
    name: 'color.shadow.strong',
    cssVariable: '--color-shadow-strong',
    description: '高强调组合阴影颜色',
    lightReference: '{role.shadowAlpha.12}',
    darkReference: '{role.shadowAlpha.12}',
    lightResolved: '#0000001F',
    darkResolved: '#0000001F',
  },
  {
    name: 'color.shadow.subtle',
    cssVariable: '--color-shadow-subtle',
    description: '低强调组合阴影颜色',
    lightReference: '{role.shadowAlpha.4}',
    darkReference: '{role.shadowAlpha.4}',
    lightResolved: '#0000000A',
    darkResolved: '#0000000A',
  },
  {
    name: 'color.tag.category.blue.background',
    cssVariable: '--color-tag-category-blue-background',
    description: '分类蓝标签背景',
    lightReference: '{role.categoryBlue.100}',
    darkReference: '{role.categoryBlue.800}',
    lightResolved: '#ECF5FF',
    darkResolved: '#18222C',
  },
  {
    name: 'color.tag.category.blue.border',
    cssVariable: '--color-tag-category-blue-border',
    description: '分类蓝标签边框',
    lightReference: '{role.categoryBlue.300}',
    darkReference: '{role.categoryBlue.500}',
    lightResolved: '#C6E2FF',
    darkResolved: '#2A598A',
  },
  {
    name: 'color.tag.category.blue.text',
    cssVariable: '--color-tag-category-blue-text',
    description: '分类蓝标签文字',
    lightReference: '{role.categoryBlue.700}',
    darkReference: '{role.categoryBlue.100}',
    lightResolved: '#337ECC',
    darkResolved: '#66B1FF',
  },
  {
    name: 'color.tag.category.cyan.background',
    cssVariable: '--color-tag-category-cyan-background',
    description: '分类青标签背景',
    lightReference: '{role.categoryCyan.100}',
    darkReference: '{role.categoryCyan.800}',
    lightResolved: '#E6F8F8',
    darkResolved: '#122222',
  },
  {
    name: 'color.tag.category.cyan.border',
    cssVariable: '--color-tag-category-cyan-border',
    description: '分类青标签边框',
    lightReference: '{role.categoryCyan.300}',
    darkReference: '{role.categoryCyan.500}',
    lightResolved: '#A7E7E7',
    darkResolved: '#2E5656',
  },
  {
    name: 'color.tag.category.cyan.text',
    cssVariable: '--color-tag-category-cyan-text',
    description: '分类青标签文字',
    lightReference: '{role.categoryCyan.700}',
    darkReference: '{role.categoryCyan.100}',
    lightResolved: '#147A7A',
    darkResolved: '#A6E3E3',
  },
  {
    name: 'color.tag.category.violet.background',
    cssVariable: '--color-tag-category-violet-background',
    description: '分类紫罗兰标签背景',
    lightReference: '{role.categoryViolet.100}',
    darkReference: '{role.categoryViolet.800}',
    lightResolved: '#F3EFFF',
    darkResolved: '#1D1929',
  },
  {
    name: 'color.tag.category.violet.border',
    cssVariable: '--color-tag-category-violet-border',
    description: '分类紫罗兰标签边框',
    lightReference: '{role.categoryViolet.300}',
    darkReference: '{role.categoryViolet.500}',
    lightResolved: '#D7C7FF',
    darkResolved: '#443D66',
  },
  {
    name: 'color.tag.category.violet.text',
    cssVariable: '--color-tag-category-violet-text',
    description: '分类紫罗兰标签文字',
    lightReference: '{role.categoryViolet.700}',
    darkReference: '{role.categoryViolet.100}',
    lightResolved: '#5B42CC',
    darkResolved: '#C8BAFF',
  },
  {
    name: 'color.text.ai',
    cssVariable: '--color-text-ai',
    description: 'AI 记录详情视觉强调，参考移动端 AI 模块',
    lightReference: '{role.aira.600}',
    darkReference: '{role.aira.600}',
    lightResolved: '#8F48FA',
    darkResolved: '#8F48FA',
  },
  {
    name: 'color.text.brand.accessible',
    cssVariable: '--color-text-brand-accessible',
    description: '浅色或暗色中性背景上满足正文对比度的主题色文字',
    lightReference: '{role.brand.800}',
    darkReference: '{role.brand.100}',
    lightResolved: '#2056A2',
    darkResolved: '#66B1FF',
  },
  {
    name: 'color.text.brand.bold',
    cssVariable: '--color-text-brand-bold',
    description: '高强调主题色文字',
    lightReference: '{role.brand.700}',
    darkReference: '{role.brand.100}',
    lightResolved: '#337ECC',
    darkResolved: '#66B1FF',
  },
  {
    name: 'color.text.brand.bolder',
    cssVariable: '--color-text-brand-bolder',
    description: '最高强调主题色文字',
    lightReference: '{role.brand.800}',
    darkReference: '{role.brand.400}',
    lightResolved: '#2056A2',
    darkResolved: '#2056A2',
  },
  {
    name: 'color.text.brand',
    cssVariable: '--color-text-brand',
    description: '主题色文字',
    lightReference: '{role.brand.600}',
    darkReference: '{role.brand.200}',
    lightResolved: '#2878E8',
    darkResolved: '#409EFF',
  },
  {
    name: 'color.text.brand.disabled',
    cssVariable: '--color-text-brand-disabled',
    description: '禁用状态主题色文字',
    lightReference: '{role.brand.400}',
    darkReference: '{role.brand.100}',
    lightResolved: '#9FCEFF',
    darkResolved: '#66B1FF',
  },
  {
    name: 'color.text.brand.hovered',
    cssVariable: '--color-text-brand-hovered',
    description: '悬停状态主题色文字',
    lightReference: '{role.brand.500}',
    darkReference: '{role.brand.100}',
    lightResolved: '#79BBFF',
    darkResolved: '#66B1FF',
  },
  {
    name: 'color.text.danger',
    cssVariable: '--color-text-danger',
    description: '危险状态文字',
    lightReference: '{role.danger.600}',
    darkReference: '{role.danger.200}',
    lightResolved: '#F53F3F',
    darkResolved: '#F56C6C',
  },
  {
    name: 'color.text.danger.disabled',
    cssVariable: '--color-text-danger-disabled',
    description: '禁用状态危险文字',
    lightReference: '{role.danger.400}',
    darkReference: '{role.danger.100}',
    lightResolved: '#FA9F9F',
    darkResolved: '#F78989',
  },
  {
    name: 'color.text.danger.hovered',
    cssVariable: '--color-text-danger-hovered',
    description: '悬停状态危险文字',
    lightReference: '{role.danger.500}',
    darkReference: '{role.danger.100}',
    lightResolved: '#F87979',
    darkResolved: '#F78989',
  },
  {
    name: 'color.text',
    cssVariable: '--color-text',
    description: '默认正文与标题文字',
    lightReference: '{role.neutral.900}',
    darkReference: '{role.neutral.150}',
    lightResolved: '#303133',
    darkResolved: '#E5EAF3',
  },
  {
    name: 'color.text.disabled',
    cssVariable: '--color-text-disabled',
    description: '禁用状态文字',
    lightReference: '{role.neutral.600}',
    darkReference: '{role.neutral.400}',
    lightResolved: '#C0C4CC',
    darkResolved: '#6C6E72',
  },
  {
    name: 'color.text.information',
    cssVariable: '--color-text-information',
    description: '信息状态文字',
    lightReference: '{role.information.600}',
    darkReference: '{role.information.200}',
    lightResolved: '#909399',
    darkResolved: '#909399',
  },
  {
    name: 'color.text.information.disabled',
    cssVariable: '--color-text-information-disabled',
    description: '禁用状态信息文字',
    lightReference: '{role.information.400}',
    darkReference: '{role.information.100}',
    lightResolved: '#C7C9CC',
    darkResolved: '#A6A9AD',
  },
  {
    name: 'color.text.information.hovered',
    cssVariable: '--color-text-information-hovered',
    description: '悬停状态信息文字',
    lightReference: '{role.information.500}',
    darkReference: '{role.information.100}',
    lightResolved: '#B1B3B8',
    darkResolved: '#A6A9AD',
  },
  {
    name: 'color.text.inverse',
    cssVariable: '--color-text-inverse',
    description: '深色背景上的反色文字',
    lightReference: '{role.neutral.100}',
    darkReference: '{role.neutral.100}',
    lightResolved: '#FFFFFF',
    darkResolved: '#FFFFFF',
  },
  {
    name: 'color.text.placeholder',
    cssVariable: '--color-text-placeholder',
    description: '占位提示文字',
    lightReference: '{role.neutral.650}',
    darkReference: '{role.neutral.350}',
    lightResolved: '#A8ABB2',
    darkResolved: '#8D9095',
  },
  {
    name: 'color.text.subtle',
    cssVariable: '--color-text-subtle',
    description: '次要正文文字',
    lightReference: '{role.neutral.800}',
    darkReference: '{role.neutral.200}',
    lightResolved: '#606266',
    darkResolved: '#CFD3DC',
  },
  {
    name: 'color.text.subtlest',
    cssVariable: '--color-text-subtlest',
    description: '最低强调辅助文字',
    lightReference: '{role.neutral.700}',
    darkReference: '{role.neutral.250}',
    lightResolved: '#909399',
    darkResolved: '#A3A6AD',
  },
  {
    name: 'color.text.success',
    cssVariable: '--color-text-success',
    description: '成功状态文字',
    lightReference: '{role.success.600}',
    darkReference: '{role.success.200}',
    lightResolved: '#00B42A',
    darkResolved: '#67C23A',
  },
  {
    name: 'color.text.success.disabled',
    cssVariable: '--color-text-success-disabled',
    description: '禁用状态成功文字',
    lightReference: '{role.success.400}',
    darkReference: '{role.success.100}',
    lightResolved: '#80D995',
    darkResolved: '#85CE61',
  },
  {
    name: 'color.text.success.hovered',
    cssVariable: '--color-text-success-hovered',
    description: '悬停状态成功文字',
    lightReference: '{role.success.500}',
    darkReference: '{role.success.100}',
    lightResolved: '#4CCA6A',
    darkResolved: '#85CE61',
  },
  {
    name: 'color.text.warning',
    cssVariable: '--color-text-warning',
    description: '警告状态文字',
    lightReference: '{role.warning.600}',
    darkReference: '{role.warning.200}',
    lightResolved: '#FF7D00',
    darkResolved: '#E6A23C',
  },
  {
    name: 'color.text.warning.disabled',
    cssVariable: '--color-text-warning-disabled',
    description: '禁用状态警告文字',
    lightReference: '{role.warning.400}',
    darkReference: '{role.warning.100}',
    lightResolved: '#FFBE80',
    darkResolved: '#EBB563',
  },
  {
    name: 'color.text.warning.hovered',
    cssVariable: '--color-text-warning-hovered',
    description: '悬停状态警告文字',
    lightReference: '{role.warning.500}',
    darkReference: '{role.warning.100}',
    lightResolved: '#FFA44C',
    darkResolved: '#EBB563',
  },
] as const;
